export const DOCUMENT_TEMPLATES_SCHEMA_VERSION = "1.0.0";
